// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"824":"906a09f8","973":"bd1e5afe"}[chunkId] || chunkId) + "." + {"135":"99db8bfd37088b90","738":"bacd146cf1ccdd57","824":"969133b2fd985557","973":"2c1719a32ed07573"}[chunkId] + ".js";
};